module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon03.e80912a6.svg";